export enum TimesheetArbeitszeitTimeSlotTypeEnum {
  WORK = 'work',
  BREAK = 'break',
  PUBLIC_HOLIDAY = 'public_holiday',
  OVERTIME = 'overtime',
  SICK = 'sick',
  VACATION = 'vacation',
  PARENTAL_LEAVE = 'parental_leave',
}

export type TimesheetArbeitszeitTimeSlot = {
  type: TimesheetArbeitszeitTimeSlotTypeEnum;
  startTime: string;
  endTime: string;
};

export enum TimesheetArbeitszeitDayTypeEnum {
  WORKDAY = 'workday',
  WEEKEND = 'weekend',
  PUBLIC_HOLIDAY = 'public_holiday',
}

export type TimesheetArbeitszeitDay = {
  date: string;
  type: TimesheetArbeitszeitDayTypeEnum;
  summary?: Partial<Record<TimesheetArbeitszeitTimeSlotTypeEnum, string>>;
  timeSlots: TimesheetArbeitszeitTimeSlot[];
};

export enum TimesheetArbeitszeitStatusEnum {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  CHANGES_REQUESTED = 'changes_requested',
  APPROVED = 'approved',
}

export type TimesheetArbeitszeit = {
  id: string;
  employeeId: string;
  startDate: string;
  endDate: string;
  days: TimesheetArbeitszeitDay[];
  status: {
    type: TimesheetArbeitszeitStatusEnum;
    updatedAt: string;
    updatedBy: string;
    detail?: string;
  };
  summary: Partial<Record<TimesheetArbeitszeitTimeSlotTypeEnum, string>>;
};

export enum TimesheetPageActions {
  SAVE = 'save',
  SUBMIT = 'submit',
  APPROVE = 'approve',
  REQUEST_CHANGES = 'request_changes',
}

export enum TimesheetsSystem {
  LEGACY = 'legacy',
  ARBEITSZEIT = 'arbeitszeit',
}
